'use client';
import React, { useState, useEffect } from 'react';
import Navbar from './Navbar';

export default function NavbarSticky() {
  const [offset, setOffset] = useState(0);
  const [stickyClass, setStickyClass] = useState('hidden');

  useEffect(() => {
    const onScroll = () => {
      const currentOffset = window.pageYOffset;
      setOffset(currentOffset);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    if (offset > 240) {
      setStickyClass('animate__animated animate__backInLeft fixed');
    } else if (offset < 140) {
      setStickyClass('hidden');
    }
  }, [offset]);

  return (
    <div className={`w-screen z-50 top-0 left-0 ${stickyClass}`}>
      <div className="bg-white w-[85vw] my-4 mx-auto rounded-3xl shadow-lg">
        <Navbar />
      </div>
    </div>
  );
}
